module.exports = __webpack_public_path__ + "static/img/headIcon.e79b1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/headIcon.png
// module id = sNGx
// module chunks = 1